import { usePermissions } from 'react-admin';

import actions, { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';

const useFormStudioEnabled = (): boolean => {
  const { permissions } = usePermissions<Actions[]>();
  return hasAccess(permissions, actions.FORM_STUDIO_ACCESS);
};

export default useFormStudioEnabled;
